export default __webpack_public_path__ + "static/bgd-hiring-33d5f07468435ecd00d438f6519f379f.webp";